(() => {
  angular
    .module('gm.common.conversion')
    .factory('GmyCurrencyConverter', GmyCurrencyConverter);

  function GmyCurrencyConverter(
    gmExchange,
    GmyCurrencies
  ) {
    'ngInject';

    return {
      fromAmountToGold,
      fromCurrencyToCurrency,
      fromCurrencyToGold,
      fromGoldTo,
    };

    function fromAmountToGold(amount = { amount: 0, currency: 'USD' }) {
      if (amount.currency === 'GAU') {
        return amount.amount;
      }
      return fromCurrencyToGold(amount.currency, amount.amount);
    }

    function fromCurrencyToCurrency(fromCurrency, toCurrency, amount, precision) {
      return fromGoldTo(
        toCurrency,
        fromCurrencyToGold(fromCurrency, amount, precision),
        precision
      );
    }

    function fromCurrencyToGold(fromCurrency, amount, origPrecision) {
      const cur = (GmyCurrencies.currencyExists(fromCurrency))
        ? gmExchange[fromCurrency]
        : gmExchange.USD;

      const precision = preparePrecision(origPrecision, 3);
      // eslint-disable-next-line no-restricted-properties
      const mult = Math.pow(10, precision);

      return Math.round((amount / cur.GAU) * mult) / mult;
    }

    function fromGoldTo(origToCurrency, amount, origPrecision) {
      // check currency
      const toCurrency = (GmyCurrencies.currencyExists(origToCurrency)) ? origToCurrency : 'USD';

      if (toCurrency === 'GAU') {
        return amount;
      }

      const precision = preparePrecision(origPrecision, 2);

      // eslint-disable-next-line no-restricted-properties
      const mult = Math.pow(10, precision);
      const cur = gmExchange[toCurrency];

      if (cur) {
        return Math.round(amount * cur.GAU * mult) / mult;
      }

      return 0;
    }

    function preparePrecision(origPrecision, defaultPrecision) {
      let precision = parseInt(origPrecision, 10);
      precision = (isNaN(precision) || (precision === Infinity) || (precision < 0))
        ? defaultPrecision : precision;

      return precision;
    }
  }
})();
